import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginService } from 'lps-navigation';
import { IDateRange } from 'src/app/action-history-queue/interfaces/date-range.interface';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class DistributionService {

  public api_uri = this.environmentService.getEnvVar('base_url_roulette');

  constructor(private http: HttpClient, private loginService: LoginService, private environmentService: EnvironmentService) { }

  distributionByQueueId(queueId: number, dateRange: IDateRange, maxResults: number, page: number) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(`${this.api_uri}/queue/${queueId}/distributions?dtIni=${dateRange.initialDate}&dtEnd=${dateRange.endDate}&max_results=${maxResults}&page=${page}`, {headers});
  }

  distributionByQueueIdPaginate(queueId, pageNumber) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(`${this.api_uri}/queue/${queueId}/distributions?max_results=10&page=${pageNumber}`, {headers});
  }

  getWithheldLeads(queueId: number, dateRange: IDateRange, maxResults: number, page: number) {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(`${this.api_uri}/lead/withheld?state=true&queueID=${queueId}&dtIni=${dateRange.initialDate}&dtEnd=${dateRange.endDate}&max_results=${maxResults}&page=${page}`, {headers});
  }

  generateReport(queueId,dtIni="",dtEnd="") {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(`${this.api_uri}/lead/withheld/report?state=true&queueID=${queueId}&dtIni=${dtIni}&dtEnd=${dtEnd}`, {headers});
  }

  
  getReportsByProduct(dtIni, dtEnd, max_results, page, order, companyId = "") {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(
      `${this.api_uri}/dashboard/lead/distribution/product?dtIni=${dtIni}&dtEnd=${dtEnd}&max_results=${max_results}&order=${order}&page=${page}&company_id=${companyId}`,
       {headers}
    );
  }

  getReportsOverview(dtIni, dtEnd, max_results, page, order, companyId = "") {
    let headers = new HttpHeaders();
    headers = headers.append('Authorization', 'Bearer ' + this.loginService.getAuthInformation().token);
    return this.http.get(
      `${this.api_uri}/dashboard/queue/overview?dtIni=${dtIni}&dtEnd=${dtEnd}&max_results=${max_results}&order=${order}&page=${page}&company_id=${companyId}`, 
      {headers}
    );
  }
}
